import React from 'react';
import { IndexRoute, Route } from 'react-router';
import { requirePermission, requirePermissions } from './helpers/requirePermission';
import AppContainer from './modules/layout/containers/App';
import Error404Container from './modules/brochure/containers/Error404';
import Error500Container from './modules/brochure/containers/Error500';
import HomepageContainer from './modules/brochure/containers/Homepage';
import BrokerActivationContainer from './modules/brochure/containers/BrokerActivationContainer';
import BrokerApplicationContainer from './modules/brochure/containers/BrokerApplicationContainer';
import WorkingWithUsContainer from './modules/brochure/containers/WorkingWithUsContainer';
import DashboardContainer from './modules/dashboard/containers/Dashboard';
import LoginContainer from './modules/auth/containers/Login';
import PasswordReminderContainer from './modules/auth/containers/PasswordReminder';
import ResetPasswordContainer from './modules/auth/containers/ResetPassword';
import AccountReportsContainer from './modules/account/containers/AccountReportsContainer';
//Complaints
import ComplaintListContainer from './modules/complaint/containers/ComplaintList';
import ComplaintShowContainer from './modules/complaint/containers/ComplaintShow';
//MTA Request
import MtaRequestListContainer from './modules/mtaRequest/containers/MtaRequestListContainer';
import MtaRequestShowContainer from './modules/mtaRequest/containers/MtaRequestShowContainer';

import CustomerListContainer from './modules/customer/containers/CustomerListContainer';
import CustomerShowContainer from './modules/customer/containers/CustomerShowContainer';
import CustomerEditContainer from './modules/customer/containers/CustomerEditContainer';
import CustomerCreateContainer from './modules/customer/containers/CustomerCreateContainer';
import ApplicationListContainer from './modules/policy/containers/ApplicationListContainer';
import MtaListContainer from './modules/policy/containers/MtaListContainer';
import RenewalListContainer from './modules/policy/containers/RenewalListContainer';
import NonRenewalListContainer from './modules/policy/containers/NonRenewalListContainer';
import ReferralListContainer from './modules/policy/containers/ReferralListContainer';
import PolicyTypesContainer from './modules/policy/containers/PolicyTypesContainer';
import PolicyListContainer from './modules/policy/containers/PolicyListContainer';
import PolicyShowContainer from './modules/policy/containers/PolicyShowContainer';
import AdminListContainer from './modules/admin/containers/AdminListContainer';
import ProductQuoteContainer from './modules/product/containers/ProductQuoteContainer';
import ProductMTAContainer from './modules/product/containers/ProductMTAContainer';
import ContentListContainer from './modules/content/containers/ContentList';
import AnnouncementList from './modules/content/containers/AnnouncementList';

import BrokerApplicationListContainer from './modules/brokerApplication/containers/BrokerApplicationListContainer';
import BrokerApplicationEditContainer from './modules/brokerApplication/containers/BrokerApplicationEditContainer';
import BrokerApplicationNewContainer from './modules/brokerApplication/containers/BrokerApplicationNewContainer';
import BrokerMessageShowContainer from './modules/brokerApplication/containers/BrokerMessageShowContainer';
import TrackingLinkListContainer from './modules/trackingLinks/containers/TrackingLinkListContainer';
import TrackingLinkNewContainer from './modules/trackingLinks/containers/TrackingLinkNewContainer';
import TrackingLinkShowContainer from './modules/trackingLinks/containers/TrackingLinkShowContainer';
import TrackingLinkEditContainer from './modules/trackingLinks/containers/TrackingLinkEditContainer';

import BrokerListContainer from './modules/broker/containers/BrokerListContainer';
import BrokerShowContainer from './modules/broker/containers/BrokerShowContainer';
import BrokerEditContainer from './modules/broker/containers/BrokerEditContainer';
import BrokerCommissionContainer from './modules/broker/containers/BrokerCommissionContainer';

import PrintJobsListContainer from './modules/printJobs/containers/PrintJobsListContainer';
import Notifications from './modules/notifications/containers/Notifications';

import CampaignsList from './modules/campaigns/containers/CampaignsList';
import CampaignNewContainer from './modules/campaigns/containers/CampaignNewContainer';
import CampaignsShowContainer from './modules/campaigns/containers/CampaignsShowContainer';
import CampaignEditContainer from './modules/campaigns/containers/CampaignEditContainer';
import ChannelsList from './modules/channel/containers/ChannelsList';
import ChannelInfoView from './modules/channel/containers/ChannelInfoView';
import ChannelFormContainerNew from './modules/channel/containers/ChannelFormContainerNew';

import SourcesList from './modules/source/containers/SourcesList';
import SourceShowContainer from './modules/source/containers/SourceShowContainer';
import SourceEditContainer from './modules/source/containers/SourceEditContainer';
import SourceCreateContainer from './modules/source/containers/SourceCreateContainer';
import SourceTypeCreateContainer from './modules/source/containers/SourceTypeCreateContainer';
import SourceTypeEditContainer from './modules/source/containers/SourceTypeEditContainer';
import ContentNewContainer from './modules/content/containers/ContentNew';
import ContentShowContainer from './modules/content/containers/ContentShow';

import ContentEditContainer from './modules/content/containers/ContentEdit';

import OrganisationListContainer from './modules/organisation/containers/OrganisationListContainer';
import OrganisationShowContainer from './modules/organisation/containers/OrganisationShowContainer';
import OrganisationEditContainer from './modules/organisation/containers/OrganisationEditContainer';
import OrganisationCreateContainer from './modules/organisation/containers/OrganisationCreateContainer';
import RoleListContainer from './modules/role/containers/RoleListContainer';
import RoleShowContainer from './modules/role/containers/RoleShowContainer';
import RoleEditContainer from './modules/role/containers/RoleEditContainer';
import RoleCreateContainer from './modules/role/containers/RoleCreateContainer';
import UserListContainer from './modules/user/containers/UserListContainer';
import UserShowContainer from './modules/user/containers/UserShowContainer';
import UserEditContainer from './modules/user/containers/UserEditContainer';
import UserEditRolesContainer from './modules/user/containers/UserEditRolesContainer';
import UserCreateContainer from './modules/user/containers/UserCreateContainer';
import PrintJobsDetailsContainer from './modules/printJobs/containers/PrintJobsDetailsContainer';
import InsurerSchemesContainer from './modules/productManagement/containers/InsurerSchemesContainer';
import BrandListContainer from './modules/productManagement/containers/BrandListContainer';
import DocumentPackEditContainer from './modules/productManagement/containers/DocumentPacksEditContainer';
import SchemeEditContainer from './modules/productManagement/containers/SchemeEditContainer';
import AdminFeesContainer from './modules/productManagement/containers/AdminFeesContainer';
import BrokerSetPasswordContainer from './modules/brochure/containers/BrokerSetPasswordContainer';
import DynamicDocumentListContainer from './modules/productManagement/containers/DynamicDocumentListContainer';
import HelpCentre from './modules/helpCentre';
import Faqs from './modules/helpCentre/Faqs';
import SystemInfo from './modules/helpCentre/SystemInfo';
import SignpostEditContainer from './modules/content/containers/SignpostEditContainer';
import AncillarySchemeDocumentListContainer from './modules/productManagement/containers/AncillarySchemeDocumentListContainer';
import ProductListContainer from './modules/product/containers/ProductListContainer';
import PendingTransactionsListContainer from './modules/account/containers/PendingTransactionsListContainer/PendingTransactionsListContainer';
import ProductManagementListContainer from './modules/productManagement/containers/ProductManagementListContainer';
import ProductSchemesContainer from './modules/productManagement/containers/ProductSchemesContainer';
import SchemeGroupEditContainer from './modules/productManagement/containers/SchemeGroupEditContainer';
import DefinitionsEditContainer from './modules/productManagement/containers/DefinitionsEditContainer';
import DeclarationEditContainer from './modules/productManagement/containers/DeclarationEditContainer';
import DocumentListContainer from './modules/productManagement/containers/DocumentListContainer';
import CountryMappingContainer from './modules/productManagement/containers/CountryMappingContainer';
import MedicalRulesContainer from './modules/productManagement/containers/MedicalRulesContainer';
import HandlersContainer from './modules/productManagement/containers/HandlersContainer';
import SmsConfirmationContainer from './modules/productManagement/containers/SmsConfirmationContainer';
import InsurerDocumentsListContainer from './modules/productManagement/containers/InsurerDocumentsListContainer';
import InsurerSchemeAuditContainer from './modules/productManagement/containers/InsurerSchemeAuditContainer';
import InsurerSchemeNotesContainer from './modules/productManagement/containers/InsurerSchemeNotesContainer';
import SchemesChannelContainer from './modules/productManagement/containers/SchemesChannelContainer';
import InsurerSchemesChannelContainer from './modules/productManagement/containers/InsurerSchemesChannelContainer';
import SchemeNotesContainer from './modules/productManagement/containers/SchemeNotesContainer';
import SchemeAuditContainer from './modules/productManagement/containers/SchemeAuditContainer';
import RemovalsListContainer from './modules/housekeeping/containers/RemovalsListContainer';
import InsurerSchemesSanctionContainer from './modules/productManagement/containers/InsurerSchemesSanctionContainer';
import SchemeSanctionsContainer from './modules/productManagement/containers/SchemesSanctionContainer';

/*
 * @param {Redux Store}
 * We require store as an argument here because we wish to get
 * state from the store after it has been authenticated.
 */

export default (store) => {
  const requireAuth = (nextState, replace, callback) => {
    const {
      auth: { authenticated },
    } = store.getState();
    if (!authenticated) {
      replace({
        pathname: '/',
        state: { nextPathname: nextState.location.pathname },
      });
    }
    callback();
  };

  const redirectAuth = (nextState, replace, callback) => {
    const {
      auth: { authenticated },
    } = store.getState();
    if (authenticated) {
      replace({
        pathname: '/dashboard',
      });
    }
    callback();
  };

  return (
    <Route path="/" component={AppContainer}>
      <IndexRoute component={HomepageContainer} onEnter={redirectAuth} />
      <Route
        path="broker/application-approved/:token"
        component={BrokerActivationContainer}
      />
      <Route path="broker/application" component={BrokerApplicationContainer} />
      <Route path="broker/contact" component={WorkingWithUsContainer} />
      <Route path="broker/set-password/:token" component={BrokerSetPasswordContainer} />
      <Route path="login" component={LoginContainer} onEnter={redirectAuth} />
      <Route
        path="password/remind"
        component={PasswordReminderContainer}
        onEnter={redirectAuth}
      />
      <Route
        path="password/reset/:token"
        component={ResetPasswordContainer}
        onEnter={redirectAuth}
      />
      <Route path="/" onEnter={requireAuth}>
        <Route path="dashboard" component={DashboardContainer} />
        <Route
          path="customers"
          component={CustomerListContainer}
          onEnter={requirePermissions(['customer.view', 'customer.view_owner'])}
        />
        <Route
          path="customers/new"
          component={CustomerCreateContainer}
          onEnter={requirePermission('customer.create')}
        />
        <Route
          path="customers/:id"
          component={CustomerShowContainer}
          onEnter={requirePermissions(['customer.view', 'customer.view_owner'])}
        />
        <Route
          path="customers/:id/edit"
          component={CustomerEditContainer}
          onEnter={requirePermission('customer.edit')}
        />

        <Route
          path="policies/print-jobs"
          component={PrintJobsListContainer}
          onEnter={requirePermission('policy.view')}
        />
        <Route
          path="policies/print-jobs/:id"
          component={PrintJobsDetailsContainer}
          onEnter={requirePermission('policy.view')}
        />

        <Route
          path="policies"
          component={PolicyTypesContainer}
          onEnter={requirePermissions(['policy.view', 'policy.view_owner'])}
        />
        <Route
          path="policies/:type/:id"
          component={PolicyShowContainer}
          onEnter={requirePermissions(['policy.view', 'policy.view_owner'])}
        />
        <Route
          path="policies/applications"
          component={ApplicationListContainer}
          onEnter={requirePermissions(['policy.view', 'policy.view_owner'])}
        />
        <Route
          path="policies/issued"
          component={PolicyListContainer}
          onEnter={requirePermissions(['policy.view', 'policy.view_owner'])}
        />
        <Route
          path="policies/mid-term-adjustments"
          component={MtaListContainer}
          onEnter={requirePermissions(['policy.view', 'policy.view_owner'])}
        />
        <Route
          path="policies/renewals"
          component={RenewalListContainer}
          onEnter={requirePermissions(['policy.renew'])}
        />
        <Route
          path="policies/referrals"
          component={ReferralListContainer}
          onEnter={requirePermission('policy.view')}
        />

        <Route
          path="policies/non-renewals"
          component={NonRenewalListContainer}
          onEnter={requirePermission('policy.view')}
        />

        <Route
          path="products"
          component={ProductListContainer}
          onEnter={requirePermissions(['policy.view', 'policy.view_owner'])}
        />
        <Route
          path="products/:id/adjustment/:policyId"
          component={ProductMTAContainer}
          onEnter={requirePermission('policy.quote')}
        />
        <Route
          path="products/:id/quote/:applicationId"
          component={ProductQuoteContainer}
          onEnter={requirePermission('policy.quote')}
        />
        <Route
          path="products/:id/quote"
          component={ProductQuoteContainer}
          onEnter={requirePermission('policy.quote')}
        />

        <Route
          path="admin"
          component={AdminListContainer}
          onEnter={requirePermission('organisation.view')}
        />
        <Route
          path="admin/complaints"
          component={ComplaintListContainer}
          onEnter={requirePermission('organisation.view')}
        />
        <Route
          path="admin/complaints/:id"
          component={ComplaintShowContainer}
          onEnter={requirePermission('organisation.view')}
        />
        <Route
          path="admin/mta-requests"
          component={MtaRequestListContainer}
          onEnter={requirePermission('policy.mta')}
        />
        <Route
          path="admin/mta-requests/:id"
          component={MtaRequestShowContainer}
          onEnter={requirePermission('policy.mta')}
        />

        <Route
          path="admin/content"
          component={ContentListContainer}
          onEnter={requirePermission('content_management.view')}
        />
        <Route
          path="admin/content/new"
          component={ContentNewContainer}
          onEnter={requirePermission('content_management.create')}
        />

        <Route
          path="admin/brokers"
          component={BrokerListContainer}
          onEnter={requirePermission('broker.view')}
        />
        <Route
          path="admin/brokers/:id"
          component={BrokerShowContainer}
          onEnter={requirePermission('broker.view')}
        />
        <Route
          path="admin/brokers/:id/edit"
          component={BrokerEditContainer}
          onEnter={requirePermission('broker.edit')}
        />
        <Route
          path="admin/brokers/:id/commissions/edit"
          component={BrokerCommissionContainer}
          onEnter={requirePermission('broker.edit')}
        />

        <Route
          path="admin/broker-applications"
          component={BrokerApplicationListContainer}
          onEnter={requirePermission('broker.view')}
        />
        <Route
          path="admin/broker-applications/new"
          component={BrokerApplicationNewContainer}
          onEnter={requirePermission('broker.create')}
        />
        <Route
          path="admin/broker-applications/:id"
          component={BrokerApplicationEditContainer}
          onEnter={requirePermission('broker.edit')}
        />
        <Route
          path="admin/broker-messages/:id"
          component={BrokerMessageShowContainer}
          onEnter={requirePermission('broker.view')}
        />

        <Route
          path="admin/tracking-links"
          component={TrackingLinkListContainer}
          onEnter={requirePermission('broker.view')}
        />
        <Route
          path="admin/tracking-links/new"
          component={TrackingLinkNewContainer}
          onEnter={requirePermission('broker.create')}
        />
        <Route
          path="admin/tracking-links/:id"
          component={TrackingLinkShowContainer}
          onEnter={requirePermission('broker.view')}
        />
        <Route
          path="admin/tracking-links/:id/edit"
          component={TrackingLinkEditContainer}
          onEnter={requirePermission('broker.view')}
        />

        <Route
          path="admin/campaign/new"
          component={CampaignNewContainer}
          onEnter={requirePermission('marketing.campaign_view')}
        />
        <Route
          path="admin/campaigns"
          component={CampaignsList}
          onEnter={requirePermission('marketing.campaign_create')}
        />
        <Route
          path="admin/campaigns/:id"
          component={CampaignsShowContainer}
          onEnter={requirePermission('marketing.campaign_view')}
        />

        <Route
          path="admin/campaigns/:id/edit"
          component={CampaignEditContainer}
          onEnter={requirePermission('marketing.campaign_create')}
        />

        {/*<Route path="admin/campaign-banners" component={CampaignBannersList}*/}
        {/*onEnter={requirePermission('marketing.source_view')}/>*/}
        {/*<Route path="admin/campaign-banners/new" component={CampaignBannersContainer}*/}
        {/*onEnter={requirePermission('marketing.source_create')}/>*/}
        {/*<Route path="admin/campaign-banners/:id" component={CampaignBannersView}*/}
        {/*onEnter={requirePermission('marketing.source_view')}/>*/}
        {/*<Route path="admin/campaign-banners/:id/edit" component={CampaignBannersEdit}*/}
        {/*onEnter={requirePermission('marketing.source_create')}/>*/}

        <Route
          path="admin/channels/new"
          component={ChannelFormContainerNew}
          onEnter={requirePermission('marketing.source_view')}
        />
        <Route
          path="admin/channels"
          component={ChannelsList}
          onEnter={requirePermission('marketing.source_view')}
        />
        <Route
          path="admin/channels/:id"
          component={ChannelInfoView}
          onEnter={requirePermission('marketing.source_view')}
        />

        <Route
          path="admin/printJobs/:id"
          component={PrintJobsDetailsContainer}
          onEnter={requirePermission('print_job.access')}
        />

        <Route
          path="admin/sources"
          component={SourcesList}
          onEnter={requirePermission('marketing.source_view')}
        />
        <Route
          path="admin/sources/new"
          component={SourceCreateContainer}
          onEnter={requirePermission('marketing.source_create')}
        />
        <Route
          path="admin/sources/:id"
          component={SourceShowContainer}
          onEnter={requirePermission('marketing.source_view')}
        />
        <Route
          path="admin/sources/:id/edit"
          component={SourceEditContainer}
          onEnter={requirePermission('marketing.source_create')}
        />

        <Route
          path="admin/source-types"
          component={SourcesList}
          onEnter={requirePermission('marketing.source_view')}
        />

        <Route
          path="admin/notifications"
          component={Notifications}
          onEnter={
            requirePermission('content_management.view') &&
            requirePermission('system.notes_view')
          }
        />

        <Route
          path="admin/source-types/new"
          component={SourceTypeCreateContainer}
          onEnter={requirePermission('marketing.source_create')}
        />
        <Route
          path="admin/source-types/:id/edit"
          component={SourceTypeEditContainer}
          onEnter={requirePermission('marketing.source_create')}
        />

        {/*<Route path="admin/content/sources" component={ContentSourcesList}*/}
        {/*onEnter={requirePermission('content_management.view')}/>*/}
        <Route
          path="admin/content/:id"
          component={ContentShowContainer}
          onEnter={requirePermission('content_management.view')}
        />
        <Route
          path="admin/content/:id/edit"
          component={ContentEditContainer}
          onEnter={requirePermission('content_management.edit')}
        />
        <Route
          path="admin/content/signpost/:id/edit"
          component={SignpostEditContainer}
          onEnter={requirePermission('content_management.edit')}
        />

        <Route
          path="admin/announcements"
          component={AnnouncementList}
          onEnter={requirePermission('content_management.view')}
        />

        <Route
          path="admin/organisations"
          component={OrganisationListContainer}
          onEnter={requirePermission('organisation.view')}
        />
        <Route
          path="admin/organisations/new"
          component={OrganisationCreateContainer}
          onEnter={requirePermission('organisation.create')}
        />
        <Route
          path="admin/organisations/:id"
          component={OrganisationShowContainer}
          onEnter={requirePermission('organisation.view')}
        />

        <Route
          path="admin/organisations/:id/edit"
          component={OrganisationEditContainer}
          onEnter={requirePermission('organisation.edit')}
        />

        <Route
          path="admin/documents"
          component={DocumentListContainer}
          onEnter={requirePermission('scheme.view')}
        />

        {/*NEW PRODUCT MANAGEMENT ROUTES*/}
        <Route
          path="admin/products"
          component={ProductManagementListContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId"
          component={ProductManagementListContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/insurers"
          component={BrandListContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/schemes"
          component={ProductSchemesContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/definitions"
          component={DefinitionsEditContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/declaration"
          component={DeclarationEditContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/documents"
          component={DocumentListContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/dynamic-documents"
          component={DynamicDocumentListContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/ancillary-scheme-documents"
          component={AncillarySchemeDocumentListContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/document-pack"
          component={DocumentPackEditContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/admin-fees"
          component={AdminFeesContainer}
          onEnter={requirePermission('scheme.view')}
        />

        <Route
          path="admin/products/:productId/schemes/channels"
          component={SchemesChannelContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/schemes/sanctions"
          component={SchemeSanctionsContainer}
          onEnter={requirePermission('scheme.edit')}
        />

        <Route
          path="admin/products/:productId/schemes/notes"
          component={SchemeNotesContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/schemes/audit"
          component={SchemeAuditContainer}
          onEnter={requirePermission('scheme.view')}
        />

        <Route
          path="admin/products/:productId/schemes/:schemeId/view-scheme"
          component={SchemeEditContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/schemes/:schemeId/edit-scheme"
          component={SchemeEditContainer}
          onEnter={requirePermission('scheme.view')}
        />

        <Route
          path="admin/products/:productId/insurers/:insurerId"
          component={InsurerSchemesContainer}
          onEnter={requirePermission('scheme.view')}
        />

        <Route
          path="admin/products/:productId/insurers/:insurerId/schemes"
          component={InsurerSchemesContainer}
          onEnter={requirePermission('scheme.view')}
        />

        <Route
          path="admin/products/:productId/insurers/:insurerId/handlers"
          component={HandlersContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/insurers/:insurerId/:schemeId/view-scheme"
          component={SchemeEditContainer}
          onEnter={requirePermission('scheme.view')}
        />

        <Route
          path="admin/products/:productId/insurers/:insurerId/:schemeId/edit-scheme"
          component={SchemeEditContainer}
          onEnter={requirePermission('scheme.edit')}
        />
        <Route
          path="admin/products/:productId/insurers/:insurerId/:schemeId/view-scheme-group"
          component={SchemeGroupEditContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/insurers/:insurerId/:schemeId/edit-scheme-group"
          component={SchemeGroupEditContainer}
          onEnter={requirePermission('scheme.edit')}
        />
        <Route
          path="admin/products/:productId/insurers/:insurerId/medical-rules"
          component={MedicalRulesContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/insurers/:insurerId/country-mapping"
          component={CountryMappingContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/insurers/:insurerId/sms-confirmation"
          component={SmsConfirmationContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/insurers/:insurerId/documents"
          component={InsurerDocumentsListContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/insurers/:insurerCode/channels"
          component={InsurerSchemesChannelContainer}
          onEnter={requirePermission('scheme.view')}
        />
        <Route
          path="admin/products/:productId/insurers/:insurerCode/sanctions"
          component={InsurerSchemesSanctionContainer}
          onEnter={requirePermission('scheme.view')}
        />

        <Route
          path="admin/products/:productId/insurers/:insurerId/notes"
          component={InsurerSchemeNotesContainer}
          onEnter={requirePermission('scheme.view')}
        />

        <Route
          path="admin/products/:productId/insurers/:insurerId/audit"
          component={InsurerSchemeAuditContainer}
          onEnter={requirePermission('scheme.view')}
        />

        <Route
          path="admin/users"
          component={UserListContainer}
          onEnter={requirePermission('user.view')}
        />
        <Route
          path="admin/users/new/:organisationId/:brokerId"
          component={UserCreateContainer}
          onEnter={requirePermission('user.create')}
        />
        <Route
          path="admin/users/new/:organisationId"
          component={UserCreateContainer}
          onEnter={requirePermission('user.create')}
        />
        <Route
          path="admin/users/:id/organisations/:organisationId/edit"
          component={UserEditRolesContainer}
          onEnter={requirePermission('user.create')}
        />
        <Route
          path="admin/users/:id/edit"
          component={UserEditContainer}
          onEnter={requirePermission('user.edit')}
        />
        <Route
          path="admin/users/:id"
          component={UserShowContainer}
          onEnter={requirePermission('user.view')}
        />

        <Route
          path="admin/roles"
          component={RoleListContainer}
          onEnter={requirePermission('role.view')}
        />
        <Route
          path="admin/roles/new"
          component={RoleCreateContainer}
          onEnter={requirePermission('role.edit')}
        />
        <Route
          path="admin/roles/:id"
          component={RoleShowContainer}
          onEnter={requirePermission('role.view')}
        />
        <Route
          path="admin/roles/:id/edit"
          component={RoleEditContainer}
          onEnter={requirePermission('role.edit')}
        />
        <Route path="help-centre" component={HelpCentre} />
        <Route path="help-centre/faqs" component={Faqs} />
        <Route path="help-centre/system-information" component={SystemInfo} />

        <Route
          path={'accounts/pending-transactions'}
          component={PendingTransactionsListContainer}
          onEnter={requirePermission('policy.underwriter')}
        />

        <Route
          path={'housekeeping/removals'}
          component={RemovalsListContainer}
          onEnter={requirePermission('policy.underwriter')}
        />

        <Route path="reports" component={AccountReportsContainer} />
      </Route>
      <Route path="500" component={Error500Container} />
      // Catch any 404s and send them to the homepage
      <Route path="*" component={Error404Container} />
    </Route>
  );
};
